import React, { useState, useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Logout from "./Logout";
import Sidebar from "./Sidebar";
import "../../assets/css/Share.css";
import AuthHeader from "../../components/AuthHeader/AuthHeader";

const Share = () => {
	return (
		<>
			<AuthHeader />
			{/* My adresses starts here */}
			<section className="my-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Sidebar />
						</div>
						<div className="col-lg-9">
							<Logout />
							{/* Share starts here */}
							<div className="share-code-wrapper">
								<div className="share-heading-wrapper">
									<div className="headings-wrapper">
										<h2>
											Share Code With Your Family <br /> Or Friend
										</h2>
										<span>
											<i className="fa fa-bullhorn" aria-hidden="true"></i>
										</span>
									</div>
									<div className="copy-code-wrapper">
										<form action="">
											<div className="copy-field-wrapper">
												<input
													type="text"
													className="form-control"
													placeholder="lorem olor sit amet, consectetur"
												/>
												<button className="btn" type="submit">
													Copy
												</button>
											</div>
										</form>
									</div>
									<div className="refrelas-wrappe">
										<div className="ref-head-wrapper">
											<h4>Your Referrals</h4>
										</div>
										<div className="ref-stats-wrapper">
											<ul>
												<li>
													<div className="stats">
														<h3>45k</h3>
														<p>Registered</p>
													</div>
												</li>
												<li>
													<div className="stats">
														<h3>45k</h3>
														<p>Successfull</p>
													</div>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="share-via-wrapper">
									<div className="share-icons-wrapper">
										<div className="heading-wrapper">
											<h4>Share Via</h4>
										</div>
										<div className="social-icons-wrapper">
											<ul>
												<li>
													<a href="#">
														<i className="fa-brands fa-whatsapp"></i>
													</a>
												</li>
												<li>
													<a href="#">
														<i className="fa-brands fa-twitter"></i>
													</a>
												</li>
												<li>
													<a href="#">
														<i className="fa-brands fa-instagram"></i>
													</a>
												</li>
												<li>
													<a href="#">
														<i className="fa-brands fa-facebook-f"></i>
													</a>
												</li>
												<li>
													<a href="#">
														<i className="fa-brands fa-facebook-messenger"></i>
													</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
							{/* Share ends here */}
						</div>
					</div>
				</div>
			</section>
			{/* My adresses ends here */}
			<Footer />
		</>
	);
};

export default Share;
